(ns bec-cljs-common.components.picker
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [clojure.string :as s]
            [bec-cljs-common.components.scroll-container :as scroll-container]))

(defonce variables (r/atom {}))

(defn default [& [{:keys [key id is-visible? on-visible on-cross-threshold initial-picked-value initial-picked-index
                          style picked-overlay-style picked-overlay-height picked-overlay-width element-height
                          element-padding container-width number-of-visible-elements color-overlay unit-type data
                          format-fn]}]]
  (let [picker-id (or id "no-id-given")
        picker-element-id (if (keyword? picker-id)
                            (name picker-id)
                            picker-id)
        element-id (str "picker-item-" picker-element-id)
        color-overlay (if color-overlay
                        (if (vector? color-overlay)
                          color-overlay
                          [color-overlay])
                        [:horizontal])
        background-color (or (:background style) (:background-color style) "var(--background)")
        picked-background-color (or (:picked-background-color style) "var(--primary-brand-color)")
        overlay-color (or (:overlay-color style) "var(--scheme-main)")
        color (or (:color style) "hsl(var(--scheme-main-hue), var(--scheme-main-saturation), var(--lightness-grey-light))")
        picked-color (or (:picked-color style) "hsl(var(--scheme-main-hue), var(--scheme-main-saturation), var(--lightness-grey-darkest))")
        border-color (:border-color style)
        picked-border-color (:picked-border-color style)
        margin (or (:margin style) "2rem")
        number-of-visible-elements (or number-of-visible-elements 4.5)
        initial-index (or initial-picked-index
                        (if (and data initial-picked-value)
                          (let [index-of-initial-value (.indexOf data initial-picked-value)]
                            (if (= index-of-initial-value -1)
                              0 index-of-initial-value))
                          (if (> (count data) (int (/ number-of-visible-elements 2)))
                            (int (/ number-of-visible-elements 2))
                            0)))
        unit-type (or unit-type "rem")
        element-height (or element-height 2.5)
        border-radius (or (:border-radius style) (str element-height unit-type))
        container-border-radius (:container-border-radius style)
        font-size (or (:font-size style) (str (* element-height 0.45) unit-type))
        adjacent-font-size (or (:adjacent-font-size style) (str (* element-height 0.6) unit-type))
        picked-font-size (or (:picked-font-size style) (str (* element-height 0.8) unit-type))
        default-container-width 12
        picked-overlay-height (or picked-overlay-height (+ element-height 1))
        picked-overlay-width (or picked-overlay-width (+ (or container-width default-container-width) 3))
        picked-overlay-left (str (/ (- (or container-width default-container-width) picked-overlay-width) 2) unit-type)
        picked-overlay-top (str (- (* (/ number-of-visible-elements 2) element-height)
                                  (/ picked-overlay-height 2)) unit-type)
        container-height (str (* element-height number-of-visible-elements) unit-type)
        container-width (str (or container-width default-container-width) unit-type)
        margin-top-bottom (str (- (* (/ number-of-visible-elements 2) element-height)
                                 (/ element-height 2)) unit-type)
        picker-vars (get @variables picker-id)
        picked-index (:picked-index picker-vars)]
    [:div
     {:key key
      :id id
      :style (merge
               {:position "relative"
                :display "flex"}
               (select-keys style [:margin-top :margin-right :margin-bottom :margin-left]))}
     (map-indexed
       (fn [index overlay-type]
         [:div
          {:id (str picker-element-id "-" overlay-type "-color-overlay-" index)
           :key (str picker-element-id "-" overlay-type "-color-overlay-" index)
           :style {:position "absolute"
                   :z-index "2"
                   :height container-height
                   :width container-width
                   :margin margin
                   :pointer-events "none"
                   :background (case overlay-type
                                 (:radial "radial")
                                 (str "radial-gradient(ellipse, transparent 5%, "
                                   overlay-color " 70%)")
                                 (:horizontal "horizontal")
                                 (str "linear-gradient(180deg, "
                                   overlay-color " 0%, "
                                   "transparent 35%, "
                                   "transparent 65%, "
                                   overlay-color " 100%)")
                                 (:vertical "vertical")
                                 (str "linear-gradient(90deg, "
                                   overlay-color " 0%, "
                                   "transparent 30%, "
                                   "transparent 70%, "
                                   overlay-color " 100%)"))
                   :border-radius container-border-radius}}])
       color-overlay)
     (->
       (into
         [scroll-container/main
          {:id (str "picker-data-container-" picker-element-id)
           :class "hide-scrollbar"
           :data data
           :only-check-component-count? true
           :on-cross-threshold (fn [props]
                                 (swap! variables
                                   #(-> (assoc-in % [picker-id :picked-value]
                                          (nth (:data props) (:component-index (:current-element props)) nil))
                                      (assoc-in [picker-id :picked-index] (:component-index (:current-element props)))))
                                 (when (fn? on-cross-threshold)
                                   (on-cross-threshold
                                     (assoc props :picked-value (nth (:data props)
                                                                  (:component-index (:current-element props)) nil)
                                                  :picked-index (:component-index (:current-element props))
                                                  :picker-variables @variables))))
           :on-visible (when (fn? on-visible)
                         (fn [props]
                           (when (= (:index (:element props)) 0)
                             (swap! variables
                               #(-> (assoc-in % [picker-id :picked-value]
                                      (nth (:data props) (:component-index (:current-element props)) nil))
                                  (assoc-in [picker-id :picked-index] (:component-index (:current-element props))))))
                           (on-visible
                             (assoc props :picked-value (nth (:data props)
                                                          (:component-index (:current-element props)) nil)
                                          :picked-index (:component-index (:element props))
                                          :picker-variables @variables))))
           :initial-visible-element-index initial-index
           :initial-visible-element-id (str element-id "-" initial-index)
           :is-visible? is-visible?
           :style {:height container-height
                   :width container-width
                   :margin margin
                   :background background-color
                   :border-radius container-border-radius
                   :scroll-padding (str element-padding unit-type)}}]
         (map-indexed
           (fn [index value]
             [:div
              {:id (str element-id "-" index)
               :key (str index)
               :style {:position "relative"
                       :z-index 1
                       :display (or (:display style) "flex")
                       :justify-content (or (:justify-content style) "center")
                       :align-items (or (:align-items style) "center")
                       :font-size (cond
                                    (= picked-index index)
                                    picked-font-size
                                    (or (= (dec picked-index) index)
                                      (= (inc picked-index) index))
                                    adjacent-font-size
                                    :else
                                    font-size)
                       :height (str element-height unit-type)
                       :color (if (= picked-index index)
                                picked-color
                                color)
                       :background (when (or (= (:display picked-overlay-style) "none"))
                                     (if (= picked-index index)
                                       picked-background-color
                                       background-color))
                       :transition "background 750ms, color 250ms, font-size 250ms ease"
                       :scroll-snap-align "center"
                       :scroll-margin-top 0
                       :padding (str element-padding unit-type)
                       :margin-left (:margin-left style)
                       :margin-right (:margin-right style)
                       :margin-top (when (= index 0)
                                     margin-top-bottom)
                       :margin-bottom (when (= index (dec (count data)))
                                        margin-top-bottom)
                       :border-top (when (and
                                           (or picked-border-color border-color)
                                           (= index 0))
                                     (str "solid 1.5px "
                                       (if (= picked-index 0)
                                         picked-border-color
                                         border-color)))
                       :border-bottom (when (or picked-border-color border-color)
                                        (str "solid 1.5px "
                                          (if (or (= (dec picked-index) index) (= picked-index index))
                                            picked-border-color
                                            border-color)))}}
              (if (fn? format-fn)
                (format-fn value {:picked-index picked-index :index index})
                value)])
           data))
       (into
         [[:div
           {:id (str "picked-overlay-" picker-element-id)
            :style (merge
                     {:position "absolute"
                      :height (str picked-overlay-height unit-type)
                      :width (str picked-overlay-width unit-type)
                      :top picked-overlay-top
                      :left picked-overlay-left
                      :margin margin
                      :pointer-events "none"
                      :background picked-background-color
                      :border-radius border-radius}
                     picked-overlay-style)}]]))]))

(defn multi [& [{:keys [key id is-visible? on-visible on-cross-threshold initial-picked-value
                        initial-picked-index  separator style picked-overlay-style picked-overlay-height
                        picked-overlay-width element-height  element-padding side-container-width
                        number-of-visible-elements container-width color-overlay unit-type data format-fn]}]]
  (let [single-id (if (vector? id)
                    (s/join "-"
                      (for [x id]
                        (if (keyword? x)
                          (name x) x)))
                    id)
        data-vector (if (vector? data) data [data])
        on-cross-threshold-vector (if (vector? on-cross-threshold)
                                    on-cross-threshold
                                    [on-cross-threshold])
        on-visible-vector (if (vector? on-visible)
                            on-visible
                            [on-visible])
        format-fn-vector (if (vector? format-fn)
                           format-fn
                           [format-fn])
        initial-picked-value (if (vector? initial-picked-value)
                               initial-picked-value
                               [initial-picked-value])
        color-overlay (if color-overlay
                        (if (vector? color-overlay)
                          color-overlay
                          [color-overlay])
                        [:horizontal])
        picked-color (or (:picked-color style) "var(--grey-darker)")
        number-of-visible-elements (or number-of-visible-elements 4.5)
        unit-type (or unit-type "rem")
        element-height (or element-height 2.5)
        element-padding (or element-padding 0.5)
        picked-font-size (str (* element-height 0.8) unit-type)
        side-container-width (or side-container-width container-width 6)
        container-width (or container-width 10)]
    [:div
     {:id single-id
      :key key
      :style {:position "relative"
              :display "flex"
              :margin (or (:margin style) "2rem")
              :border-radius (:border-radius style)}}
     (map-indexed
       (fn [index data]
         [:div
          {:key (if (vector? id)
                  (if (< index (count id))
                    (nth id index)
                    (str (last id) "-" index))
                  (str id "-" index))
           :style {:display "flex"
                   :place-content "center"
                   :align-items "center"}}
          [default
           {:id (if (vector? id)
                  (if (< index (count id))
                    (nth id index)
                    (if (keyword? (last id))
                      (keyword (str (name (last id)) "-" index))
                      (str (last id) "-" index)))
                  (if (keyword? id)
                    (keyword (str (name id) "-" index))
                    (str id "-" index)))
            :data data
            :format-fn (if (< index (count format-fn-vector))
                         (nth format-fn-vector index)
                         (last format-fn-vector))
            :initial-picked-value (when (< index (count initial-picked-value))
                                    (nth initial-picked-value index))
            :initial-picked-index (when (< index (count initial-picked-index))
                                    (nth initial-picked-index index))
            :on-cross-threshold (if (< index (count on-cross-threshold-vector))
                                  (nth on-cross-threshold-vector index)
                                  (last on-cross-threshold-vector))
            :on-visible (if (< index (count on-visible-vector))
                          (nth on-visible-vector index)
                          (last on-visible-vector))
            :is-visible? is-visible?
            :color-overlay color-overlay
            :number-of-visible-elements number-of-visible-elements
            :container-width (if (or (= index (dec (count data-vector))) (= index 0))
                               side-container-width container-width)
            :element-height element-height
            :element-padding element-padding
            :picked-overlay-height picked-overlay-height
            :picked-overlay-width picked-overlay-width
            :picked-overlay-style (merge
                                    (cond
                                      (= index 0)
                                      {:border-radius "35px 0 0 35px"}
                                      (= index (dec (count data-vector)))
                                      {:border-radius "0 35px 35px 0"}
                                      :else
                                      {:border-radius "0"})
                                    picked-overlay-style)
            :style (merge
                     {:color "hsl(var(--scheme-main-hue), var(--scheme-main-saturation), var(--lightness-grey-light))"
                      :background "hsl(var(--scheme-main-hue), var(--scheme-main-saturation), var(--lightness-grey-darker))"
                      :picked-background-color "var(--primary-brand-color-dark)"
                      :picked-color picked-color
                      :margin 0
                      :margin-left (when (= index (dec (count data-vector))) (:margin-left style))
                      :margin-right (when (= index 0) (:margin-right style))
                      :border-radius (cond
                                       (= index 0)
                                       "35px 0 0 35px"
                                       (= index (dec (count data-vector)))
                                       "0 35px 35px 0"
                                       :else
                                       "0")
                      :justify-content (cond
                                         (= index 0)
                                         "flex-end"
                                         (= index (dec (count data-vector)))
                                         "flex-start"
                                         :else
                                         "center")}
                     (dissoc style :margin-right :margin-left))}]
          (when (not (= index (dec (count data-vector))))
            [:div
             {:key (str single-id "-separator-" index)
              :style {:position "absolute"
                      :font-size picked-font-size
                      :z-index 2
                      :color picked-color
                      :padding-left (str (if (or (= index 0) (= index (dec (count data-vector))))
                                           side-container-width
                                           container-width)
                                      unit-type)
                      :pointer-events "none"}}
             (if (vector? separator)
               (if (< index (count separator))
                 (nth separator index)
                 (last separator))
               (or separator ":"))])])
       data-vector)]))
